import {postData, renderElement} from "./utils/common";
import {priorityColorClass} from "./utils/consts";

const AriaLabelMessages = {
  ADD: `Добавить в избранное`,
  REMOVE: `Удалить из избранного`,
};

const TextMessages = {
  ADD: `В избранное`,
  REMOVE: `В избранном`,
};

const FavouriteBtnType = {
  TOOL: `tool`,
  TITLE: `title`,
};

const getFavoriteItemTemplate = (name, priority, deadline, isBurnTask, url, id, favoriteUrl) => `<li class="favourites__item">
<div class="favourites__name">
  <button type="button" class="favourites__favourite favourite favourite--modal js-add-favorite"
    data-favorite-place="favorite-list" aria-label="Удалить из избранного" data-task-id="${id}"
    data-favorite-url="${favoriteUrl}">
    <svg class="favourite__icon" width="14" height="13">
      <use xlink:href="/img/sprite.svg#star-icon"></use>
    </svg>
  </button>
  <a class="favourites__task" href="${url}">
    ${name}
  </a>
</div>
<div class="favourites__info priority">
  ${
    deadline
      ? `<span class="favourites__day button ${isBurnTask ? `button--burn` : `button--current`}">
  ${deadline}</span>`
      : ``
  }
  <span class="priority__block ${priorityColorClass[priority]}" aria-label="Приоритет ${priority}">${priority}</span>
</div>
</li>`;

const addFavorite = ({addFavoriteSelector = `.js-add-favorite`, activeClass = `active`}) => {
  const favoriteMenuListElement = document.querySelector(`.js-favorite-list`);
  const favouriteTitleBtnElement = document.querySelector(`.js-title-add-favourite`);
  const favouriteToolBtnElement = document.querySelector(`.js-tool-add-favourite`);
  const favouriteTextElement = document.querySelector(`.js-favourite-text`);

  const removeFavoriteMenuItem = (addFavoriteButton, id, menuListElement) => {
    if (addFavoriteButton.dataset.favoritePlace === `favorite-list`) {
      const item = document.querySelector(`[data-task-id="${id}"]:not([data-favorite-place="favorite-list"])`);
      addFavoriteButton.closest(`.favourites__item`).remove();

      if (item) {
        item.classList.remove(activeClass);
      }
    } else {
      const item = menuListElement.querySelector(`[data-task-id="${id}"]`);

      item.closest(`.favourites__item`).remove();
    }
  };

  const addFavoriteMenuItem = (addButtonElement, menuListElement, taskId, favoriteUrl) => {
    const parentElement = addButtonElement.closest(`.js-favorite-item`);
    const taskDeadlineElement = parentElement.querySelector(`.js-favorite-deadline`);
    const taskName = parentElement.querySelector(`.js-favorite-name`).textContent;
    const taskPriority = +parentElement.querySelector(`.js-favorite-prioriry`).textContent.trim();
    const taskDeadline = taskDeadlineElement ? taskDeadlineElement.textContent : null;
    const isBurnTask = taskDeadlineElement ? taskDeadlineElement.classList.contains(`button--burn`) : null;
    const url = parentElement.dataset.type === `taskPage` ? location.href : parentElement.querySelector(`.js-favorite-name`).href;

    renderElement(menuListElement, getFavoriteItemTemplate(taskName, taskPriority, taskDeadline, isBurnTask, url, taskId, favoriteUrl));
  };

  const changeFavoriteStatus = async (evt) => {
    const button = evt.target.classList.contains(addFavoriteSelector) ? evt.target : evt.target.closest(addFavoriteSelector);
    const taskId = button.dataset.taskId;
    // Проверка какая кнопка была нажата
    const isTitleBtn = button.dataset.type === FavouriteBtnType.TITLE;
    const isToolBtn = button.dataset.type === FavouriteBtnType.TOOL;

    const URL = button.dataset.favoriteUrl;

    const result = await postData(`taskId=${taskId}`, URL);

    if (result.length) {
      if (result === `not`) {
        button.classList.remove(activeClass);

        removeFavoriteMenuItem(button, taskId, favoriteMenuListElement);

        // Удаляет активный класс второй кнопке на той же странице
        if (isToolBtn) {
          favouriteTextElement.textContent = TextMessages.ADD;
          favouriteTitleBtnElement.classList.remove(activeClass);
        } else if (isTitleBtn) {
          favouriteTextElement.textContent = TextMessages.ADD;
          favouriteToolBtnElement.classList.remove(activeClass);
        }
      } else if (result === `add`) {
        button.classList.add(activeClass);

        addFavoriteMenuItem(button, favoriteMenuListElement, taskId, URL);

        // Добавляем активный класс второй кнопке на той же странице
        if (isToolBtn) {
          favouriteTextElement.textContent = TextMessages.REMOVE;
          favouriteTitleBtnElement.classList.add(activeClass);
        }
      }
    }
  };

  const onDocumentClick = async (evt) => {
    if (evt.target.classList.contains(addFavoriteSelector) || evt.target.closest(addFavoriteSelector)) {
      evt.preventDefault();
      await changeFavoriteStatus(evt);
    }
  };

  document.addEventListener(`click`, onDocumentClick);
};

export default addFavorite;
